module.exports = __webpack_public_path__ + "static/media/bear-white.85abf3b8.svg";